<template>
  <div>
    <b-modal
      no-fade
      size="xl2"
      id="modal-programa"
      no-close-on-esc
      no-close-on-backdrop
      title="Gerenciamento de Programa"
      @show="onShow()"
    >
      <UIBlocker :isShow="isReporting">
        Gerando Relatorio. Aguarde...
      </UIBlocker>
      <UIBlocker :isShow="isLoading"> Aguarde... </UIBlocker>
      <div>
        <b-form-row>
          <b-col sm="12" md="12" lg="3">
            <b-form-group
              label="Código do Programa"
              label-size="sm"
              label-for="programa_id"
            >
              <b-form-input
                size="sm"
                id="programa_id"
                v-model="programa.programa_id"
                disabled
                trim
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="8" lg="8">
            <b-form-group
              label-size="sm"
              label="Cliente"
              label-for="cliente_id"
            >
              <v-select
                id="cliente_id"
                :options="combos.clientes"
                label="cliente_id"
                disabled
                :reduce="(c) => c.cliente_id"
                :clearable="false"
                v-model="programa.cliente_id"
              >
                <template v-slot:option="option">{{
                  `${option.cliente_id} - ${option.razao_social}`
                }}</template>
                <template v-slot:selected-option="option">{{
                  `${option.cliente_id} - ${option.razao_social}`
                }}</template>
                <template #no-options="{}">Sem dados a serem exibidos</template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-button
              v-if="acao !== 'view'"
              v-show="tabIndex === 0"
              size="sm"
              block
              @click="editPrograma()"
              variant="primary"
              style="margin-top: 27px"
            >
              <i class="far fa-edit"></i> Alterar
            </b-button>
          </b-col>
          <b-col sm="12" md="12" lg="12">
            <b-form-group label="Título" label-size="sm" label-for="titulo">
              <b-textarea
                disabled
                rows="3"
                no-resize
                id="titulo"
                trim
                v-model="programa.titulo"
              >
              </b-textarea>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row class="mb-2">
          <b-col sm="12" md="2" lg="2">
            <b-form-group
              label="Total Empréstimo BID US$"
              label-size="sm"
              label-for="vl_reajustado_emprestimo_bid_m2"
            >
              <b-form-input
                size="sm"
                disabled
                id="vl_reajustado_emprestimo_bid_m2"
                v-model="programa.vl_reajustado_emprestimo_bid_m2"
                trim
                v-mask="{
                  alias: 'numeric',
                  autoUnmask: true,
                  greedy: true,
                  radixPoint: ',',
                  groupSeparator: '.',
                  digits: 2,
                  digitsOptional: false,
                  autoGroup: true,
                  allowPlus: false,
                  allowMinus: false,
                  onUnMask: function(maskedValue) {
                    var x = maskedValue.split(',');
                    return x[0].replace(/\./g, '') + '.' + x[1];
                  },
                }"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6" md="2" lg="2">
            <b-form-group
              label="Total Contra-Partida US$"
              label-size="sm"
              label-for="vl_reajustado_emprestimo_contrapartida_m2"
            >
              <b-form-input
                size="sm"
                disabled
                id="vl_reajustado_emprestimo_contrapartida_m2"
                v-model="programa.vl_reajustado_emprestimo_contrapartida_m2"
                trim
                v-mask="{
                  alias: 'numeric',
                  autoUnmask: true,
                  greedy: true,
                  radixPoint: ',',
                  groupSeparator: '.',
                  digits: 2,
                  digitsOptional: false,
                  autoGroup: true,
                  allowPlus: false,
                  allowMinus: false,
                  onUnMask: function(maskedValue) {
                    var x = maskedValue.split(',');
                    return x[0].replace(/\./g, '') + '.' + x[1];
                  },
                }"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="2" lg="2">
            <b-form-group
              label="Total Desembolsado BID US$"
              label-size="sm"
              label-for="vl_desembolsado_bid_m2"
            >
              <b-form-input
                size="sm"
                disabled
                id="vl_desembolsado_bid_m2"
                v-model="programa.vl_desembolsado_bid_m2"
                trim
                v-mask="{
                  alias: 'numeric',
                  autoUnmask: true,
                  greedy: true,
                  radixPoint: ',',
                  groupSeparator: '.',
                  digits: 2,
                  digitsOptional: false,
                  autoGroup: true,
                  allowPlus: false,
                  allowMinus: false,
                  onUnMask: function(maskedValue) {
                    var x = maskedValue.split(',');
                    return x[0].replace(/\./g, '') + '.' + x[1];
                  },
                }"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="6" md="2" lg="2">
            <b-form-group
              label="Total Reconhecido BID US$"
              label-size="sm"
              label-for="vl_reconhecido_bid_m2"
            >
              <b-form-input
                size="sm"
                disabled
                id="vl_reconhecido_bid_m2"
                v-model="programa.vl_reconhecido_bid_m2"
                trim
                v-mask="{
                  alias: 'numeric',
                  autoUnmask: true,
                  greedy: true,
                  radixPoint: ',',
                  groupSeparator: '.',
                  digits: 2,
                  digitsOptional: false,
                  autoGroup: true,
                  allowPlus: false,
                  allowMinus: false,
                  onUnMask: function(maskedValue) {
                    var x = maskedValue.split(',');
                    return x[0].replace(/\./g, '') + '.' + x[1];
                  },
                }"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="12" md="4" lg="2">
            <b-form-group
              label="Total Rec. Contra-Partida"
              label-size="sm"
              label-for="vl_reconhecido_contrapartida_m2"
            >
              <b-form-input
                size="sm"
                disabled
                id="vl_reconhecido_contrapartida_m2"
                v-model="programa.vl_reconhecido_contrapartida_m2"
                trim
                v-mask="{
                  alias: 'numeric',
                  autoUnmask: true,
                  greedy: true,
                  radixPoint: ',',
                  groupSeparator: '.',
                  digits: 2,
                  digitsOptional: false,
                  autoGroup: true,
                  allowPlus: false,
                  allowMinus: false,
                  onUnMask: function(maskedValue) {
                    var x = maskedValue.split(',');
                    return x[0].replace(/\./g, '') + '.' + x[1];
                  },
                }"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-tabs
          content-class="v-tab-content"
          v-model="tabIndex"
          active-nav-item-class="v-tab-active"
          small
        >
          <b-tab title="EAP">
            <b-form-row>
              <b-col>
                <b-row>
                  <b-col lg="4">
                    <b-button
                      variant="primary"
                      size="sm"
                      class="my-md-2"
                      @click="doShowConsolidacao()"
                    >
                      <i class="fa fa-search"></i> Consolidação
                    </b-button>
                    <b-button
                      variant="secondary"
                      v-b-modal.modal-rpt
                      size="sm"
                      class="my-md-2"
                    >
                      <i class="fa fa-print"></i> Relatórios
                    </b-button>
                    <b-button
                      size="sm"
                      class="my-md-2"
                      @click="showTaxaPlanner"
                      variant="info"
                    >
                      Taxa Planner
                    </b-button>
                  </b-col>
                  <b-col class="text-right mb-2">
                    <b-button
                      variant="success"
                      size="sm"
                      @click="newWBS(1, null)"
                    >
                      <i class="fa fa-plus"></i> Adicionar Nível
                    </b-button>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="12">
                    <table ref="tblFiltro" class="tblFiltro">
                      <thead></thead>
                      <tbody>
                        <tr>
                          <td style="width: 200px;">
                            <b-input-group>
                              <b-form-input
                                size="sm"
                                class="txtFiltro"
                                ref="txtFiltroWBSID"
                                maxlength="10"
                                v-model="filtro.wbs_id"
                              />
                              <b-input-group-append
                                ><b-button
                                  size="sm"
                                  variant="primary"
                                  class="btnFiltro"
                                  @click="onShow"
                                  ><i class="fas fa-filter"></i></b-button
                              ></b-input-group-append>
                            </b-input-group>
                          </td>
                          <td style="width: 480px">
                            <b-input-group>
                              <b-form-input
                                size="sm"
                                class="txtFiltro"
                                ref="txtFiltroComponente"
                                maxlength="255"
                                v-model="filtro.componente"
                              />
                              <b-input-group-append
                                ><b-button
                                  size="sm"
                                  class="btnFiltro"
                                  variant="primary"
                                  @click="onShow"
                                  ><i class="fas fa-filter"></i></b-button
                              ></b-input-group-append>
                            </b-input-group>
                          </td>
                          <td style="width: 150px">
                            <b-form-select
                              @change="onShow"
                              id="situacao_diretoria"
                              size="sm"
                              class="cboFiltro"
                              v-model="filtro.situacao"
                            >
                              <b-form-select-option value="-1"
                                >** TODAS **</b-form-select-option
                              >
                              <b-form-select-option value=""
                                >** NÃO DEFINIDA **</b-form-select-option
                              >
                              <b-form-select-option value="PLANEJADO"
                                >PLANEJADO</b-form-select-option
                              >
                              <b-form-select-option value="EM PREPARAÇÃO"
                                >EM PREPARAÇÃO</b-form-select-option
                              >
                              <b-form-select-option value="EM LICITAÇÃO"
                                >EM LICITAÇÃO</b-form-select-option
                              >
                              <b-form-select-option value="EM HOMOLOGAÇÃO"
                                >EM HOMOLOGAÇÃO</b-form-select-option
                              >
                              <b-form-select-option value="EM CONTRATAÇÃO"
                                >EM CONTRATAÇÃO</b-form-select-option
                              >
                              <b-form-select-option
                                value="AGUARDANDO ORDEM DE SERVIÇO"
                                >AGUARDANDO ORDEM DE
                                SERVIÇO</b-form-select-option
                              >
                              <b-form-select-option
                                value="CONTRATO EM ANDAMENTO"
                                >CONTRATO EM ANDAMENTO</b-form-select-option
                              >
                              <b-form-select-option value="PARALISADO"
                                >PARALISADO</b-form-select-option
                              >
                              <b-form-select-option value="FINALIZADO"
                                >FINALIZADO</b-form-select-option
                              >
                              <b-form-select-option value="CANCELADO"
                                >CANCELADO</b-form-select-option
                              >
                            </b-form-select>
                          </td>
                          <td style="width: 90px"></td>
                          <td style="width: 80px"></td>
                          <td style="width: 120px"></td>
                          <td style="width: 120px"></td>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="12">
                    <zk-table
                      ref="tblWBS"
                      :data="wbs.data"
                      :columns="wbs.fields"
                      stripe
                      border
                      :is-fold="false"
                      show-header
                      :show-row-hover="false"
                      empty-text="Sem estrutura definida"
                      :expand-type="false"
                      :selection-type="false"
                      :cell-style="getRowStyle"
                      :row-style="getRowStyle"
                      @row-click="doCellClick"
                      @row-mouseenter="onRowEnter"
                    >
                      <template slot="situacao_diretoria" slot-scope="scope">
                        <span
                          class="badge badge-grey my-badge"
                          v-if="
                            scope.row.ind_analitico &&
                              (scope.row.situacao_diretoria ==
                                'EM PREPARAÇÃO' ||
                                scope.row.situacao_diretoria == 'PLANEJADO')
                          "
                        >
                          {{ scope.row.situacao_diretoria }}
                        </span>
                        <span
                          class="badge badge-yellow my-badge"
                          v-if="
                            scope.row.ind_analitico &&
                              (scope.row.situacao_diretoria == 'EM LICITAÇÃO' ||
                                scope.row.situacao_diretoria ==
                                  'EM HOMOLOGAÇÃO')
                          "
                        >
                          {{ scope.row.situacao_diretoria }}
                        </span>
                        <span
                          class="badge badge-orange my-badge"
                          v-if="
                            scope.row.ind_analitico &&
                              (scope.row.situacao_diretoria ==
                                'EM CONTRATAÇÃO' ||
                                scope.row.situacao_diretoria ==
                                  'AGUARDANDO ORDEM DE SERVIÇO')
                          "
                        >
                          {{ scope.row.situacao_diretoria }}
                        </span>
                        <span
                          class="badge badge-success my-badge"
                          v-if="
                            scope.row.ind_analitico &&
                              scope.row.situacao_diretoria ==
                                'CONTRATO EM ANDAMENTO'
                          "
                        >
                          {{ scope.row.situacao_diretoria }}
                        </span>
                        <span
                          class="badge badge-danger my-badge"
                          v-if="
                            scope.row.ind_analitico &&
                              scope.row.situacao_diretoria == 'PARALISADO'
                          "
                        >
                          {{ scope.row.situacao_diretoria }}
                        </span>
                        <span
                          class="badge badge-primary my-badge"
                          v-if="
                            scope.row.ind_analitico &&
                              scope.row.situacao_diretoria == 'FINALIZADO'
                          "
                        >
                          {{ scope.row.situacao_diretoria }}
                        </span>
                        <span
                          class="badge badge-black my-badge"
                          v-if="
                            scope.row.ind_analitico &&
                              scope.row.situacao_diretoria == 'CANCELADO'
                          "
                        >
                          {{ scope.row.situacao_diretoria }}
                        </span>
                      </template>
                      <template slot="ind_analitico" slot-scope="scope">
                        <span
                          v-if="scope.row.ind_analitico == false"
                          class="badge badge-primary my-badge"
                          >Sintético</span
                        >
                        <span
                          v-if="scope.row.ind_analitico == true"
                          class="badge badge-danger my-badge"
                          >Analítico
                        </span>
                      </template>
                      <template slot="ind_fonte" slot-scope="scope">
                        <span
                          v-if="scope.row.ind_fonte == 1"
                          class="badge badge-primary my-badge"
                          >BID</span
                        >
                        <span
                          v-if="scope.row.ind_fonte == 2"
                          class="badge badge-success my-badge"
                          >ESTADO
                        </span>
                        <span
                          v-if="scope.row.ind_fonte == 3"
                          class="badge badge-warning my-badge"
                          >AMBOS
                        </span>
                        <span v-if="scope.row.ind_fonte == null" class="">
                        </span>
                      </template>
                      <template slot="perc_execucao_fisica" slot-scope="scope">
                        <!-- <span v-show="scope.row.perc_execucao_fisica >= 10">
                          <b-progress
                            show-progress
                            striped
                            :max="100"
                            variant="success"
                            height="30px"
                          >
                            <b-progress-bar
                              :value="scope.row.perc_execucao_fisica"
                              :label-html="
                                `<span style='color:black'>${(
                                  (scope.row.perc_execucao_fisica / 100) *
                                  100
                                ).toFixed(0)}%</span>`
                              "
                            ></b-progress-bar>
                          </b-progress>
                        </span> -->
                        <div style="position: relative;">
                          <b-progress
                            striped
                            :max="100"
                            :variant="
                              scope.row.perc_execucao_fisica < 25
                                ? 'danger'
                                : scope.row.perc_execucao_fisica > 75
                                ? 'success'
                                : 'warning'
                            "
                            height="20px"
                          >
                            <b-progress-bar
                              :value="scope.row.perc_execucao_fisica"
                            ></b-progress-bar>
                          </b-progress>
                          <span
                            style="position:absolute; top: -3px; width: 100%; font-size:0.8em; color:black; text-align: center"
                            >{{
                              `${scope.row.perc_execucao_fisica.toFixed(0)}%`
                            }}</span
                          >
                        </div>
                      </template>

                      <template slot="acoes" slot-scope="scope">
                        <b-button
                          size="sm"
                          variant="success"
                          @click="newWBS(2, scope.row)"
                          title="Adicionar Sub Nível"
                        >
                          <i class="fas fa-sort-amount-down-alt"></i>
                        </b-button>
                        <b-button
                          size="sm"
                          variant="primary"
                          title="Alterar"
                          @click="editWBS(scope.row)"
                        >
                          <i class="fas fa-edit"></i>
                        </b-button>
                        <b-button
                          size="sm"
                          variant="danger"
                          title="Excluir"
                          @click="deleteWBS(scope.row)"
                        >
                          <i class="fas fa-trash"></i>
                        </b-button>
                      </template>
                    </zk-table>
                  </b-col>
                </b-row>
              </b-col>
            </b-form-row>
          </b-tab>
          <b-tab title="Empréstimos">
            <SubTabAditivosEmprestimo :programa="programa" :acao="curAcao" />
          </b-tab>
          <b-tab title="Desembolsos">
            <SubTabDesembolsos :programa="programa" :acao="curAcao" />
          </b-tab>
          <b-tab title="Fluxo de Caixa">
            <sub-tab-fluxo-caixa
              :programa="programa"
              :acao="curAcao"
            ></sub-tab-fluxo-caixa>
          </b-tab>
          <b-tab title="Anexos">
            <TabAnexosPrograma :programa="programa" :acao="curAcao" />
          </b-tab>
        </b-tabs>
      </div>
      <template v-slot:modal-footer>
        <b-button size="sm" @click="() => $bvModal.hide('modal-programa')"
          >Fechar</b-button
        >
      </template>
    </b-modal>
    <b-modal no-fade id="modal-rpt" title="Relatórios">
      <b-form-select
        text-field="titulo"
        value-field="nomeArquivo"
        v-model="relatorioCorrente"
        :options="relatorios"
        :select-size="22"
      ></b-form-select>
      <template v-slot:modal-footer>
        <b-button size="sm" variant="primary" @click="doGerarRelatorio()"
          >Gerar</b-button
        >
        <b-button size="sm" @click="() => $bvModal.hide('modal-rpt')"
          >Fechar</b-button
        >
      </template>
    </b-modal>
    <ModalConsolidacao :programa="programa" />
    <ModalNivelSintetico :wbs="curWBS" :acao="curAcao" @updatedWBS="onShow()" />
    <ModalNivel
      :wbs="curWBS"
      :acao="curAcao"
      @insertedWBS="onInsertWBS()"
      @updatedWBS="onShow()"
    />
    <ModalTaxaPlanner :programaID="programaID" />
    <ModalEditPrograma :curPrograma="programa" />
    <b-modal
      @ok="doNewWBS()"
      id="modalNovoTipo"
      title="Qual o tipo de nível deseja adicionar?"
      ok-title="Criar"
      cancel-title="Cancelar"
      footer-class="confirm-dialog"
      button-size="sm"
      noFade
    >
      <div class="d-block text-center">
        <b-form-radio-group
          v-model="novo_wbs_tipo"
          :options="novo_wbs_tipo_opcoes"
        >
        </b-form-radio-group>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { baseApiUrl, showError } from "@/global";

import axios from "axios";
import ModalNivel from "./ModalNivel";
import ModalNivelSintetico from "./ModalNivelSintetico";
import ModalEditPrograma from "./ModalEditPrograma";
import TabAnexosPrograma from "./TabAnexosPrograma";
import ModalTaxaPlanner from "./ModalTaxaPlanner";

import ZkTable from "vue-table-with-tree-grid";
import { bidbus } from "@/main";

import ModalConsolidacao from "./ModalConsolidacao.vue";
import SubTabDesembolsos from "./SubTabDesembolsos.vue";
import SubTabAditivosEmprestimo from "./SubTabAditivosEmprestimo.vue";
import SubTabFluxoCaixa from "./SubTabFluxoCaixa.vue";

import barramento from "@/barramento";
import UIBlocker from "@/components/layout/UIBlocker";

export default {
  name: "ModalPrograma",
  components: {
    ModalNivel,
    ModalNivelSintetico,
    ModalEditPrograma,
    ZkTable,
    ModalConsolidacao,
    SubTabDesembolsos,
    SubTabAditivosEmprestimo,
    TabAnexosPrograma,
    UIBlocker,
    ModalTaxaPlanner,
    SubTabFluxoCaixa,
  },
  props: {
    programa: { type: Object, required: true },
    acao: { type: String, required: true, default: "view" },
  },
  computed: {
    // getTotalDesembolsadoBIDM2: function() {

    //   let valor = this.programa.desembolsos.reduce((accum, item) => {
    //     return parseFloat(accum) + parseFloat(item.vl_desembolso_m2);
    //   }, 0.0);

    //   return formatMoney(valor, 2, "", ".", ",");
    // },
    programaID: {
      get() {
        if (this.programa.programa_id) {
          return this.programa.programa_id;
        } else {
          return "";
        }
      },
    },
  },
  data: function() {
    return {
      filtro: {
        situacao: -1,
        wbs_id: "",
        componente: "",
      },
      taxaPlanner: 0,
      isReporting: false,
      isLoading: false,
      novo_wbs_item_corrente: {},
      novo_wbs_tipo: "1",
      novo_wbs_tipo_opcoes: [
        { text: "Sintético", value: "1" },
        { text: "Analítico", value: "2" },
      ],
      relatorios: [
        {
          url: "/bid/relatorios/eap/[programaid]",
          nomeArquivo: "EAP",
          titulo: "EAP",
        },
        {
          url: "/bid/relatorios/pep/[programaid]",
          nomeArquivo: "PEP",
          titulo: "PEP",
        },
        {
          url: "/bid/relatorios/poa/[programaid]",
          nomeArquivo: "POA",
          titulo: "POA",
        },
        {
          url: "/bid/relatorios/pa-consultoria/[programaid]",
          nomeArquivo: "PA_CONSULTORIA",
          titulo: "PA CONSULTORIA",
        },
        {
          url: "/bid/relatorios/pa-nao-consultoria/[programaid]",
          nomeArquivo: "PA_NAO_CONSULTORIA",
          titulo: "PA NÃO CONSULTORIA",
        },
        {
          url: "/bid/relatorios/pa-obras/[programaid]",
          nomeArquivo: "PA-OBRAS",
          titulo: "PA OBRAS",
        },
        {
          url: "/bid/relatorios/loa/[programaid]",
          nomeArquivo: "LOA",
          titulo: "LOA",
        },
        {
          url: "/bid/relatorios/ldo/[programaid]",
          nomeArquivo: "LDO",
          titulo: "LDO",
        },
        {
          url: "/bid/relatorios/situacao-bid/[programaid]",
          nomeArquivo: "SITUACAO_BID",
          titulo: "Situação BID",
        },
        {
          url: "/bid/relatorios/situacao-estado/[programaid]",
          nomeArquivo: "SITUACAO_ESTADO",
          titulo: "Situação Estado",
        },
        {
          url: "/bid/relatorios/nivel-comprometimento/[programaid]",
          nomeArquivo: "NIVEL_COMPROMETIMENTO",
          titulo: "Nível Comprometimento",
        },
        {
          url: "/bid/relatorios/plano-financeiro/[programaid]",
          nomeArquivo: "PLANO_FINANCEIRO",
          titulo: "Plano Financeiro",
        },
        {
          url: "/bid/relatorios/reconhecimento-gastos/[programaid]",
          nomeArquivo: "RECONHECIMENTO_GASTOS",
          titulo: "Reconhecimento de Gastos",
        },
        {
          url: "/bid/relatorios/tabela-obras/[programaid]",
          nomeArquivo: "TABELA_OBRAS",
          titulo: "Tabela de Obras",
        },
        {
          url: "/bid/relatorios/tabela-projetos/[programaid]",
          nomeArquivo: "TABELA_PROJETOS",
          titulo: "Tabela de Projetos",
        },
        {
          url: "/bid/relatorios/diretoria-bid/[programaid]",
          nomeArquivo: "DIRETORIA_BID",
          titulo: "Diretoria BID",
        },
        {
          url: "/bid/relatorios/diretoria-estado/[programaid]",
          nomeArquivo: "DIRETORIA_ESTADO",
          titulo: "Diretoria Estado",
        },
        {
          url: "/bid/relatorios/planejamento/[programaid]",
          nomeArquivo: "PLANEJAMENTO",
          titulo: "Planejamento",
        },
        {
          url: "/bid/relatorios/valores-bid-estado/[programaid]",
          nomeArquivo: "VALORES_BID_ESTADO",
          titulo: "Valores BID/Estado",
        },
        {
          url: "/bid/relatorios/licitacao/[programaid]",
          nomeArquivo: "LICITACAO",
          titulo: "Licitação",
        },
        {
          url: "/bid/relatorios/elegibilidade/[programaid]",
          nomeArquivo: "ELEGIBILIDADE",
          titulo: "Elegibilidade",
        },
        {
          url: "/bid/relatorios/relacao-contratos/[programaid]",
          nomeArquivo: "RELACAO_CONTRATOS",
          titulo: "Relação de Contratos",
        },
        {
          url: "/bid/relatorios/planilha-esp-financeiro/[programaid]",
          nomeArquivo: "PLANILHA_ESP_FINANCEIRO",
          titulo: "Planilha ESP Financeiro",
        },
        {
          url: "/bid/relatorios/pmr/[programaid]",
          nomeArquivo: "PMR",
          titulo: "PMR",
        },
      ],
      relatorioCorrente: "",
      tabIndex: 0,
      curWBS: {},
      curAcao: "view",
      wbs: {
        busy: false,
        data: [],
        fields: [
          {
            prop: "wbs_id",
            label: "WBS",
            width: "200px",
            minWidth: "200px",
          },
          {
            prop: "componente",
            label: "Componente",
            width: "480px",
          },
          {
            prop: "situacao_diretoria",
            label: "Sit. Contrato",
            type: "template",
            template: "situacao_diretoria",
            width: "150px",
            minWidth: "150px",
          },
          {
            prop: "ind_analitico",
            label: "Tipo Nível",
            type: "template",
            template: "ind_analitico",
            width: "90px",
            minWidth: "90px",
          },
          {
            prop: "ind_fonte",
            label: "Fonte",
            type: "template",
            template: "ind_fonte",
            width: "80px",
            minWidth: "80px",
          },
          {
            prop: "perc_execucao_fisica",
            label: "% Exec. Física",
            type: "template",
            template: "perc_execucao_fisica",
            width: "120px",
            minWidth: "120px",
          },
          {
            prop: "actions",
            label: "Ações",
            type: "template",
            template: "acoes",
            width: "120px",
            minWidth: "120px",
          },
        ],
      },
      combos: {
        clientes: [],
      },
    };
  },
  methods: {
    doGerarRelatorio() {
      if (!this.relatorioCorrente) return;
      this.$bvModal.hide("modal-rpt");
      let _item = this.relatorios.filter(
        (f) => f.nomeArquivo == this.relatorioCorrente
      )[0];

      this.rptExecRelatorio(_item.url, _item.nomeArquivo);
    },
    showTaxaPlanner() {
      this.$bvModal.show("modal-taxa-planner");
    },
    // eslint-disable-next-line
    doCellClick($event) {
      [...document.getElementsByClassName("zk-table__body-row")].forEach(
        (element) => {
          element.onmouseleave = null;
          element.onmouseenter = null;
          element.classList.remove("zk-selected");
        }
      );

      [
        ...document.getElementsByClassName(
          "zk-table__body-row zk-table--stripe-row"
        ),
      ].forEach((element) => {
        element.onmouseleave = null;
        element.onmouseenter = null;
        element.classList.remove("zk-selected");
      });

      let parentTR = $event.target.closest("tr");
      parentTR.classList.add("zk-selected");
    },
    // eslint-disable-next-line
    onRowEnter($event) {
      [...document.getElementsByClassName("zk-table__body-row")].forEach(
        (element) => {
          element.onmouseleave = null;
          element.onmouseenter = null;
          element.classList.remove("mzk-hover");
        }
      );

      let parentTR = $event.target.closest("tr");
      parentTR.classList.add("mzk-hover");
    },

    doShowConsolidacao() {
      barramento.$emit("programaChanged", this.programa);
      this.$bvModal.show("modal-consolidacao");
    },
    getRowStyle(row) {
      if (row.children && row.children.length > 0)
        return { backgroundColor: "#efefef", borderColor: "#bbb" };

      return { borderColor: "#bbb" };
    },

    editWBS(item) {
      this.isLoading = true;
      axios
        .get(
          `${baseApiUrl}/bid/programawbs/${btoa(item.programa_id)}/${
            item.wbs_id
          }`
        )
        .then((resp) => {
          this.isLoading = false;
          this.curAcao = "edit";
          this.curWBS = { ...resp.data };
          if (item.ind_analitico) this.$bvModal.show("modal-nivel");
          else this.$bvModal.show("modal-nivel-sintetico");
        })
        .catch((err) => {
          this.isLoading = false;
          showError(err);
          console.log(err);
        });
    },
    //************************************************************************/
    deleteWBS(item) {
      this.$bvModal
        .msgBoxConfirm(
          `Excluir o Nível ${item.wbs_id} do programa ${item.programa_id}?`,
          {
            noFade: true,
            okTitle: "Excluir",
            cancelTitle: "Cancelar",
            buttonSize: "sm",
            footerClass: "confirm-dialog",
          }
        )
        .then((yesno) => {
          if (yesno) {
            this.wbs.busy = true;
            axios
              .delete(
                `${baseApiUrl}/bid/programawbs/${btoa(item.programa_id)}/${
                  item.wbs_id
                }`
              )
              .then(() => {
                this.onShow();
                this.wbs.busy = false;
              })
              .catch((err) => {
                this.wbs.busy = false;
                showError(err);
              });
          }
        })
        .catch((err) => {
          showError(err);
          console.log(err);
        });
    },
    //************************************************************************/
    // origem = botao adicionar novo raiz = 1.
    //          botao adicionar subnivel = 2
    newWBS(origem, item) {
      if (origem == 1) {
        // veio do botao raiz =
        this.novo_wbs_item_corrente = {
          _origem: 1,
          ind_analitico: false,
          programa_id: this.programa.programa_id,
          ind_fonte: 1,
          wbs_id: "",
        };
      } else if (origem == 2) {
        // veio do botao subnivel
        this.novo_wbs_item_corrente = item;
        this.novo_wbs_item_corrente._origem = 2;
      }
      this.$bvModal.show("modalNovoTipo");
    },
    //************************************************************************/
    doNewWBS() {
      if (this.novo_wbs_tipo == 1) {
        // sintetico
        if (
          this.novo_wbs_item_corrente &&
          this.novo_wbs_item_corrente._origem == 1
        )
          this.newWBSRaiz();
        if (
          this.novo_wbs_item_corrente &&
          this.novo_wbs_item_corrente._origem == 2
        )
          this.newWBSSubNivel();
      } else if (this.novo_wbs_tipo == 2) {
        //analitico
        if (
          this.novo_wbs_item_corrente &&
          this.novo_wbs_item_corrente._origem == 1
        )
          this.newWBSRaiz();

        if (
          this.novo_wbs_item_corrente &&
          this.novo_wbs_item_corrente._origem == 2
        )
          this.newWBSSubNivel();
      }
    },
    //************************************************************************/
    newWBSRaiz() {
      // sintetico

      axios
        .get(
          `${baseApiUrl}/bid/programawbs/${btoa(
            this.programa.programa_id
          )}/ultimonivel`
        )
        .then((resp) => {
          this.curAcao = "new";
          this.curWBS = {
            programa_id: this.programa.programa_id,
            ind_analitico: this.novo_wbs_tipo == 2,
            wbs_id:
              resp.data && resp.data != "" ? parseInt(resp.data.wbs_id) + 1 : 1,
          };
          if (this.novo_wbs_tipo == 1)
            this.$bvModal.show("modal-nivel-sintetico");
          else this.$bvModal.show("modal-nivel");
        })
        .catch((ex) => {
          showError(ex);
          console.log(ex);
        });
    },
    //************************************************************************/
    newWBSSubNivel() {
      // sintetico
      axios
        .get(
          `${baseApiUrl}/bid/programawbs/${btoa(this.programa.programa_id)}/${
            this.novo_wbs_item_corrente.wbs_id
          }/ultimosubnivel`
        )
        .then((resp) => {
          let _arr = new Array();
          let _newID = "";
          if (resp.data == "") {
            _newID = this.novo_wbs_item_corrente.wbs_id + ".1";
          } else {
            _arr = resp.data.wbs_id.split(".");
            _arr[_arr.length - 1] = parseInt(_arr.slice(-1)[0]) + 1;
            _newID = _arr.join(".");
          }

          this.curAcao = "new";
          this.curWBS = {
            programa_id: this.programa.programa_id,
            wbs_id: _newID,
            componente: "",
            ind_analitico: this.novo_wbs_tipo == 2,
            tipo_contrato_id: null,
            item_pa: "",
            moeda_id: null,
            orgao: "",
            cotacao_base: 1,
            ind_fonte: null,
            unidade_executora: "",
            fonte_financ: "",
            ind_tp_contratacao: null,
            ind_status_pa: null,
            nome_trecho: "",
            objeto: "",
            local: "",
            vl_contrato_planej: 0,
            vl_contrato_planej_m2: 0,
            montante_estim_bid: 0,
            montante_estim_contrapartida: 0,
            extensao: 0,
            un: "",
            regional: "",
            elegibilidade: "",
            dt_elegibilidade: null,
            ind_metodo_aquisicao: 0,
            ind_tp_revisao: 0,
            comentarios_sn: "",
            nr_processo_licitacao: "",
            nr_chamamento_publico: "",
            nr_proc_chamamento_publico: "",
            dt_chamamento_publico: null,
            dt_entrega_mi: null,
            nr_gms: "",
            nr_concorrencia: "",
            nr_bid: "",
            nr_portaria: "",
            vl_estimado_licitacao: 0,
            dt_public_licit: null,
            dt_abert_licit: null,
            cbr1: "",
            cbr1_arquivo_id: 0,
            cbr1_data: null,
            cbr2: "",
            cbr2_arquivo_id: 0,
            cbr2_data: null,
            cbr2_dt_abert_proposta: null,
            cbr2_dt_reuniao_negoc: null,
            cbr3: "",
            cbr3_arquivo_id: 0,
            cbr3_data: null,
            dt_assinatura_contrato_pa: null,
            dt_assinatura_contrato: null,
            dt_os: null,
            nr_contrato: "",
            nr_prism: "",
            nome_empresa: "",
            vl_inicial_contrato: 0,
            vl_total_reajustes: 0,
            vl_total_reajustes_m2: 0,
            prazo_inicial_dias: 0,
            prazo_meses: 0,
            prazo_ajustado_dias: 0,
            dt_ini_contrato: null,
            situacao_diretoria: "",
          };
          if (this.novo_wbs_tipo == 1)
            this.$bvModal.show("modal-nivel-sintetico");
          else this.$bvModal.show("modal-nivel");
        })
        .catch((ex) => {
          showError(ex);
          console.log(ex);
        });
    },

    //************************************************************************/
    editPrograma() {
      this.$bvModal.show("modal-edit-programa");
    },
    //************************************************************************/
    onInsertWBS() {
      this.curAcao = "edit";
      bidbus.$emit("insertedWBS");
      this.onShow();
    },
    //************************************************************************/
    onShow() {
      this.isLoading = true;
      this.wbs.data = [];
      this.tabIndex = 0;
      // wbs
      //.get()

      let _dados = {
        situacao: this.filtro.situacao,
        programa_id: this.programa.programa_id,
        wbs_id: this.filtro.wbs_id,
        componente: this.filtro.componente,
      };
      axios
        .post(`${baseApiUrl}/bid/programawbs/wbssituacao`, _dados)
        .then((resp) => {
          if (!Array.isArray(resp.data)) this.wbs.data = [];
          else {
            this.wbs.data = resp.data;
          }
          this.isLoading = false;
        })
        .catch((ex) => {
          this.isLoading = false;
          showError(ex);
          console.log(ex);
        });
    },
    //************************************************************************/
    loadCombos() {
      // clientes
      axios
        .get(`${baseApiUrl}/clientes`)
        .then((resp) => {
          this.combos.clientes = resp.data;
        })
        .catch(showError);
    },
    rptExecRelatorio(url, nomeArquivo) {
      this.isReporting = true;

      url = url.replace("[programaid]", btoa(this.programa.programa_id));

      axios({
        url: `${baseApiUrl}${url}`,
        method: "GET",
        responseType: "blob",
      })
        .then((res) => {
          let blob = new Blob([res.data], { type: "application/octet-stream" });
          let downloadElement = document.createElement("a");
          let href = window.URL.createObjectURL(blob);
          downloadElement.href = href;
          downloadElement.download =
            nomeArquivo + "_" + this.programa.programa_id + ".xlsm";
          document.body.appendChild(downloadElement);
          downloadElement.click();
          document.body.removeChild(downloadElement);
          window.URL.revokeObjectURL(href);
          this.isReporting = false;
        })
        .catch(() => {
          this.isReporting = false;
          showError;
        });
    },
  },
  // watch: {
  //   projeto: {
  //     deep: true,
  //     handler(){
  //       console.log("mudei");
  //       this.onShow();
  //     }
  //   },
  // },
  created() {},
  mounted() {
    this.loadCombos();
  },
};
</script>

<style>
.v-tab-active {
  background-color: #007bff !important;
  color: white !important;
}

.nav-tabs .nav-link {
  border-color: #ddd !important;
}

.v-tab-content {
  border: 1px solid #ddd;
  padding: 10px;
  box-shadow: 1px 1px 5px 0 #ccc;
}

.nav-tabs .nav-link:hover {
  background-color: #ddd !important;
  color: #333 !important;
}
.vs__dropdown-toggle {
  padding: 0 !important;
}

.vs__selected {
  margin: 2px 2px 2px !important;
}

.expandIcon {
  margin-right: 5px;
  cursor: pointer;
}

/* ZK TABLE CUSTOM*/
.zk-table__header-row {
  background-color: #333 !important;
  color: #fff !important;
}

.zk-table__cell-inner .zk-table--firstProp-header-inner {
  color: #fff !important;
}

.zk-selected {
  background-color: #007bff !important;
  color: white !important;
}

.badge-orange {
  background-color: orange !important;
}

.badge-yellow {
  background-color: yellow !important;
}

.badge-black {
  background-color: #000;
  color: white;
}

.badge-grey {
  background-color: #aaa;
}

.mzk-hover {
  background-color: #999 !important;
  color: white !important;
}

.mzk-hover > td {
  background-color: #999 !important;
  color: white !important;
}

.zk-selected > td {
  background-color: #007bff !important;
  color: white !important;
}

.tblFiltro {
  width: 100%;
  height: 30px;
  background-color: #333;
  color: white;
  border: 0.05px solid #fff;
}
.tblFiltro > tr > td {
  border: 1px solid #fff;
}

.txtFiltro {
  max-height: 24px;
  font-size: 10px;
  border-radius: 2px;
}

.btnFiltro {
  font-size: 9px;
}

.cboFiltro {
  font-size: 10px;
}
</style>
